import React from "react";
import ContactForm from "../ContactFrom/ContactForm";
import { Link } from "react-router-dom";
import Address from "../../images/contact/location.webp";
import Phone from "../../images/contact/mobile.webp";
import Email from "../../images/contact/mail.webp";
import MainCta from "../../images/contact/main-cta.webp";
import MovingDots from "../movingDots/MovingDots";
import "./contactSection.css";
const ContactSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <div
        className="services services--style3 pb-0"
        style={{ paddingTop: "40px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="sectionTitle text-center mb-30 mt-10">
                <h1 className="sectionTitle__big">We’re Here to Help</h1>
                <p style={{ fontSize: "18px" }}>
                  At Jainam Jivika Foundation, we value your thoughts, questions and feedback. Feel free to get in touch if you want to learn more about our initiatives, explore collaborative opportunities or volunteer with us. Let’s work together to make a difference!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact contact--layout1 pt-0 pb-40" id="feature" style={{ position: "relative", overflow: "hidden" }}>
        <MovingDots />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="col-lg-6 mx-auto">
            <div className="sectionTitle text-center">
              <h2 className="sectionTitle__big" style={{ fontSize: "32px" }}>
                Our Contact Details
              </h2>
            </div>
          </div>
          <div className="row justify-content-center align-items-stretch pt-100 gy-65">
            <div className="col-lg-3 col-md-6 col-sm-8 col-11 mb-0" style={{ minHeight: '100%' }}>
              <div className="contactBlock text-center h-100">
                <figure className="contactBlock__figure">
                  <i className="fa-solid fa-envelope cb-icon"></i>
                </figure>
                <div className="contactBlock__content">
                  <h2 className="contactBlock__heading text-uppercase">
                    Email ID
                  </h2>
                  <span className="contactBlock__phone connect">
                    <a
                      className="contact-links"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="mailto:info@JJFIndia.com"

                    >
                      {" "}
                      info@JJFIndia.com {" "}
                    </a>{" "}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-8 col-11 mb-0" style={{ minHeight: '100%' }}>
              <div className="contactBlock text-center h-100">
                <figure className="contactBlock__figure">
                  <i className="fa-solid fa-phone cb-icon"></i>
                </figure>
                <div className="contactBlock__content">
                  <h2 className="contactBlock__heading text-uppercase">
                    Contact Number
                  </h2>
                  <span className="contactBlock__phone connect">
                    <a className="contact-links" rel="noopener noreferrer" href="tel:+919552895289">
                      +91 95 5289 5289
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-8 col-11 mb-0" style={{ minHeight: '100%' }}>
              <div className="contactBlock text-center h-100">
                <figure className="contactBlock__figure">
                  <i className="fa-solid fa-location-dot cb-icon"></i>
                </figure>
                <div className="contactBlock__content">
                  <h2 className="contactBlock__heading text-uppercase">Our Location</h2>
                  <span className="contactBlock__phone connect">
                    <a className="contact-links" target="_blank" rel="noopener noreferrer" href="https://maps.app.goo.gl/mCvV6mqmRgEaRtLL6">Jainam Tower, Thergaon, Pune - 411033</a>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-8 col-11 mb-0" style={{ minHeight: '100%' }}>
              <div className="contactBlock text-center h-100">
                <figure className="contactBlock__figure">
                  <i className="fa-solid fa-clock cb-icon"></i>
                </figure>
                <div className="contactBlock__content">
                  <h2 className="contactBlock__heading text-uppercase">Working Hours</h2>
                  <span className="contactBlock__phone connect">
                    <span className="contact-links">Mon - Sat, 10AM - 6PM</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="services services--style3 pb-40 gray-bg"
        style={{ paddingTop: "40px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="sectionTitle text-center mb-20">
                <span className="sectionTitle__small justify-content-center">
                  <i className="fa-solid fa-heart btn__icon"></i>
                  Get in Touch with Us
                </span>
                <h2 className="sectionTitle__big">
                  Have Questions or Suggestions?
                </h2>
                <p style={{ fontSize: "18px" }}>
                  Fill out the form below to reach us. One of our team members
                  will get back to you as soon as possible.
                </p>
              </div>
            </div>
          </div>
          <div className="jjf-contact-wrap mt-20">
            <div className="jjf-contact-card">
              {/* Info panel — brand-dark */}
              <div
                className="jjf-contact-info"
                style={{
                  background:
                    "linear-gradient(157deg, #241a10 0%, #2e2113 52%, #3d2a12 100%)",
                }}
              >
                <MovingDots light />
                <span className="jjf-blob jjf-blob--1" aria-hidden="true"></span>
                <span className="jjf-blob jjf-blob--2" aria-hidden="true"></span>
                <h3>Contact Us</h3>
                <p>Say something to start a conversation with us!</p>
                <ul className="jjf-info-list">
                  <li>
                    <span className="jjf-info-ic"><i className="fa-solid fa-phone"></i></span>
                    <a href="tel:+919552895289">+91 95 5289 5289</a>
                  </li>
                  <li>
                    <span className="jjf-info-ic"><i className="fa-solid fa-envelope"></i></span>
                    <a href="mailto:info@JJFIndia.com">info@JJFIndia.com</a>
                  </li>
                  <li>
                    <span className="jjf-info-ic"><i className="fa-solid fa-location-dot"></i></span>
                    <span>Jainam Tower, Sai Park, Thergaon, Pune - 411033, Maharashtra, India.</span>
                  </li>
                </ul>
                <div className="jjf-info-socials">
                  <a href="https://www.instagram.com/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                  <a href="https://www.linkedin.com/company/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                  <a href="https://www.facebook.com/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                  <a href="https://www.youtube.com/@TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
                </div>
              </div>
              {/* Form panel */}
              <div className="jjf-contact-formpanel">
                <ContactForm />
              </div>
            </div>

            {/* Map */}
            <div className="jjf-contact-map">
              <iframe
                title="Jainam Jivika Foundation location"
                src="https://maps.google.com/maps?q=Jainam%20Tower%2C%20Sai%20Park%2C%20Thergaon%2C%20Pune%20411033&z=16&output=embed"
                loading="lazy"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>
          </div>
          <div className="pb-40 gray-bg">
          </div>
        </div>

      </div>

      <div
        className="services services--style3 pb-0"
        style={{ paddingTop: "40px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="sectionTitle text-center mb-40">
                <span className="sectionTitle__small justify-content-center">
                  <i className="fa-solid fa-heart btn__icon"></i>
                  Find Answers, Empower Your Journey
                </span>
                <h2 className="sectionTitle__big">
                  Frequently Asked Questions
                </h2>
                <p style={{ fontSize: "18px" }}>
                  Before reaching out, you can explore our FAQs section for quick
                  answers to common queries.
                </p>
                <>
                  <div className="aboutContent__buttons d-flex justify-content-center mt-4">
                    <Link to="/faqs" onClick={ClickHandler} className="jjf-btn">
                      Visit the FAQs Page
                      <i className="fa-solid fa-heart"></i>
                    </Link>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="services services--style3 pb-0 gray-bg"
        style={{ paddingTop: "40px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="sectionTitle text-center mb-65">
                <span className="sectionTitle__small justify-content-center">
                  <i className="fa-solid fa-heart btn__icon"></i>
                  Stay Connected, Stay Inspired
                </span>
                <h2 className="sectionTitle__big">Follow Us on Social Media</h2>
                <p style={{ fontSize: "18px" }}>
                  Stay updated on our latest events, campaigns and initiatives.
                </p>
                <>
                  <div className="aboutContent__buttons d-flex justify-content-center mt-4">
                    <div className="row">
                      <ul className="social-media row flex-wrap justify-content-center gap-2">
                        <li className="col-sm-1 col-2 social-media">
                          <a

                            className="instagram"
                            href="https://www.instagram.com/TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a

                            className="linkedin"
                            href="https://www.linkedin.com/company/TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a

                            className="facebook"
                            href="https://www.facebook.com/TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a
                            onClick={ClickHandler}
                            className="youtube"
                            href="https://www.youtube.com/@TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 20 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8 10L13.19 7L8 4V10ZM19.56 2.17C19.69 2.64 19.78 3.27 19.84 4.07C19.91 4.87 19.94 5.56 19.94 6.16L20 7C20 9.19 19.84 10.8 19.56 11.83C19.31 12.73 18.73 13.31 17.83 13.56C17.36 13.69 16.5 13.78 15.18 13.84C13.88 13.91 12.69 13.94 11.59 13.94L10 14C5.81 14 3.2 13.84 2.17 13.56C1.27 13.31 0.69 12.73 0.44 11.83C0.31 11.36 0.22 10.73 0.16 9.93C0.0900001 9.13 0.0599999 8.44 0.0599999 7.84L0 7C0 4.81 0.16 3.2 0.44 2.17C0.69 1.27 1.27 0.69 2.17 0.44C2.64 0.31 3.5 0.22 4.82 0.16C6.12 0.0899998 7.31 0.0599999 8.41 0.0599999L10 0C14.19 0 16.8 0.16 17.83 0.44C18.73 0.69 19.31 1.27 19.56 2.17Z"
                                  fill="white"
                                />
                              </svg>
                            </i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a

                            className="x"
                            href="https://x.com/TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className=''>
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0)">
                                  <mask id="mask0" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
                                    <path d="M0 0H14V14H0V0Z" fill="white" />
                                  </mask>
                                  <g mask="url(#mask0)">
                                    <path d="M11.025 0.65625H13.172L8.482 6.03025L14 13.3442H9.68L6.294 8.90925L2.424 13.3442H0.275L5.291 7.59425L0 0.65725H4.43L7.486 4.71025L11.025 0.65625ZM10.27 12.0562H11.46L3.78 1.87725H2.504L10.27 12.0562Z" fill="white" />
                                  </g>
                                </g>
                                <defs>
                                  <clipPath id="clip0">
                                    <rect width="14" height="14" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a
                            onClick={ClickHandler}
                            className="thread"
                            href="https://www.threads.net/@TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M5.44962 4.623C6.99662 2.974 9.23963 2 12.0166 2C16.5816 2 19.6086 4.631 20.5666 8.277C20.634 8.5336 20.5967 8.80644 20.4629 9.03552C20.329 9.2646 20.1097 9.43113 19.8531 9.4985C19.5965 9.56586 19.3237 9.52854 19.0946 9.39473C18.8655 9.26092 18.699 9.0416 18.6316 8.785C17.9046 6.022 15.6756 4 12.0156 4C9.72962 4 8.03562 4.789 6.90962 5.99C5.77362 7.202 5.14062 8.913 5.14062 10.875V13.125C5.14062 15.087 5.77362 16.798 6.90962 18.009C8.03562 19.212 9.72962 20 12.0156 20C13.6706 20 14.9836 19.616 15.9916 18.995C17.0066 18.37 17.6116 17.541 17.7816 16.59C17.9766 15.494 17.7366 14.742 17.3236 14.199C17.0971 13.9068 16.8217 13.6561 16.5096 13.458C16.3746 14.207 16.1336 14.914 15.7696 15.468C14.4276 17.507 11.8616 17.682 10.1696 17.007C9.25363 16.642 8.46863 15.643 8.22463 14.572C8.07648 13.9581 8.12583 13.3132 8.36563 12.729C8.63063 12.093 9.12163 11.551 9.82063 11.139C10.5126 10.73 11.5406 10.542 12.5596 10.514C13.1736 10.497 13.8396 10.538 14.5096 10.647C14.3696 9.997 14.1326 9.512 13.8656 9.263C13.3816 8.813 12.5796 8.496 11.7756 8.501C10.9986 8.507 10.3396 8.806 9.94563 9.436C9.80506 9.6609 9.58091 9.82076 9.32248 9.88039C9.06406 9.94003 8.79253 9.89456 8.56763 9.754C8.34272 9.61343 8.18287 9.38929 8.12323 9.13086C8.0636 8.87244 8.10906 8.6009 8.24963 8.376C9.08663 7.038 10.4656 6.511 11.7626 6.501C13.0326 6.492 14.3406 6.973 15.2286 7.799C16.1266 8.635 16.5126 10.006 16.6126 11.253C17.4866 11.634 18.3126 12.193 18.9176 12.99C19.6986 14.02 20.0346 15.348 19.7506 16.941C19.4606 18.565 18.4356 19.839 17.0406 20.698C15.6726 21.54 13.9846 22 12.0156 22C9.23962 22 6.99563 21.026 5.45063 19.377C3.91463 17.739 3.14062 15.513 3.14062 13.125V10.875C3.14062 8.487 3.91463 6.261 5.45063 4.623H5.44962ZM14.5996 12.7C13.9474 12.5593 13.2807 12.4969 12.6136 12.514C11.7226 12.538 11.0976 12.707 10.8366 12.861C10.4526 13.088 10.2866 13.319 10.2126 13.498C10.1337 13.6987 10.1204 13.9193 10.1746 14.128C10.2966 14.664 10.6996 15.066 10.9106 15.149C12.0366 15.599 13.4456 15.361 14.0986 14.369C14.3336 14.011 14.5206 13.409 14.5986 12.7H14.5996Z"
                                  fill="white"
                                />
                              </svg>
                            </i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a

                            className="pinterest"
                            href="https://in.pinterest.com/TeamJJFIndia/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-pinterest-p"></i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a
                            onClick={ClickHandler}
                            className="medium"
                            href="https://medium.com/@TeamJJFIndia"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className=""><svg width="14" height="14" viewBox="0 0 24 24" fill="none"><ellipse cx="6.6" cy="12" rx="4.6" ry="5.3" fill="currentColor" /><ellipse cx="15.2" cy="12" rx="2.2" ry="5.3" fill="currentColor" /><ellipse cx="20.4" cy="12" rx="1" ry="5.3" fill="currentColor" /></svg></i>
                          </a>
                        </li>

                        <li className="col-sm-1 col-2 social-media">
                          <a

                            className="whatsapp"
                            href="https://wa.me/919552895289"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-whatsapp"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="volunteer pt-40 pb-40 white-bg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-10">
              <div className="volunteerUser">
                <div className="volunteerUser__box">
                  <div className="volunteerUser__thumb">
                    <img src={MainCta} alt="Join Us and Make a Difference" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="aboutContent aboutContent--style3">
                <div className="sectionTitle mb-20">
                  <span className="sectionTitle__small">
                    <i className="fa-solid fa-heart btn__icon"></i>
                    Let’s Collaborate
                  </span>
                  <h2 className="sectionTitle__big">
                    Join Hands, Create a Brighter Tomorrow!
                  </h2>
                </div>
                <p
                  className="aboutContent__text"
                  style={{ textAlign: "justify" }}
                >
                  Are you a corporate organisation, NGO or influencer looking
                  to partner with us? Drop us a message to discuss how we can
                  work together to create a lasting impact.
                </p>
                <p className="pt-20" style={{ fontSize: "18px" }}>
                  <strong>Partnership Enquiries:</strong>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:info@JJFIndia.com"
                    className="text-blue-500"
                  >
                    {" "}
                    info@JJFIndia.com {" "}
                  </a>{" "}
                </p>
                <a
                  href="#feature"
                  className="jjf-btn"
                  style={{ marginTop: "6px", position: "relative", zIndex: 5 }}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("feature");
                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                  }}
                >
                  Start a Partnership <i className="fa-solid fa-heart"></i>
                </a>
                {/* <div className="aboutContent__buttons">
                  <Link
                    onClick={ClickHandler}
                    className="btn btn--styleOne btn--primary it-btn"
                    to="mailto:info@JJFIndia.com"
                  >
                    <span className="btn__text">Reach Out to Us Today</span>
                    <i className="fa-solid fa-heart btn__icon"></i>
                    <span className="it-btn__inner">
                      <span className="it-btn__blobs">
                        <span className="it-btn__blob"></span>
                        <span className="it-btn__blob"></span>
                        <span className="it-btn__blob"></span>
                        <span className="it-btn__blob"></span>
                      </span>
                    </span>
                    <svg
                      className="it-btn__animation"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                    >
                      <defs>
                        <filter>
                          <feGaussianBlur
                            in="SourceGraphic"
                            result="blur"
                            stdDeviation="10"
                          ></feGaussianBlur>
                          <feColorMatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                            result="goo"
                          ></feColorMatrix>
                          <feBlend
                            in2="goo"
                            in="SourceGraphic"
                            result="mix"
                          ></feBlend>
                        </filter>
                      </defs>
                    </svg>
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;

